import { render, staticRenderFns } from "./submit-answer-sheet.vue?vue&type=template&id=b158a9e8&scoped=true&"
import script from "./submit-answer-sheet.vue?vue&type=script&lang=js&"
export * from "./submit-answer-sheet.vue?vue&type=script&lang=js&"
import style0 from "./submit-answer-sheet.vue?vue&type=style&index=0&id=b158a9e8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b158a9e8",
  null
  
)

export default component.exports